<app-billing-section-header></app-billing-section-header>

<div (click)="setShowBillingModuleEvent()" class="checkbox optional-wrapper" [class.not-show-billing]="!showBillingModule">
  <input type="checkbox" [checked]="showBillingModule">
  <label class="item-name">
    <span class="optional-billing">{{'BOOKING_MODULE.BILLING.OPTIONAL' | transloco}}</span>
  </label>
</div>